import React, { useEffect, useState } from "react";
import "./FixDataFilterSelector.scss";
import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { CommonEnums } from "../../../../enums/common.enums";
import CloseIcon from "../../../../components/icons/CloseIcon";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";

// let listData: any[] = [];
const FixDataFilterSelector = ({
  formik,
  type,
  placeholder,
  customData = [],
}: {
  formik: any;
  type: string;
  placeholder: string;
  customData?: any[];
}) => {
  let listData: any[] = [];
  //   const [state, setState] = useState({
  //     isLoading: false,
  //     listData: [],
  //     agentListBox: false,
  //   });

  const onClickRemove = () => {
    formik.setFieldValue(type, "");
  };

  switch (type) {
    case CommonEnums?.selectorType?.property_type:
      listData = customData.map((item: any) => ({
        id: item._id,
        itemName: item.name,
      }));
      break;

    case CommonEnums?.selectorType?.subscription_type:
      listData = [
        {
          id: CommonEnums.subscriptionType.property_marketing.key,
          itemName: CommonEnums.subscriptionType.property_marketing.value,
        },

        {
          id: CommonEnums.subscriptionType.agent_marketing.key,
          itemName: CommonEnums.subscriptionType.agent_marketing.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.subscription_plan:
      listData = [
        {
          id: CommonEnums.subscriptionPlan.standard.key,
          itemName: CommonEnums.subscriptionPlan.standard.value,
        },

        {
          id: CommonEnums.subscriptionPlan.growth.key,
          itemName: CommonEnums.subscriptionPlan.growth.value,
        },
        {
          id: CommonEnums.subscriptionPlan.success.key,
          itemName: CommonEnums.subscriptionPlan.success.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.status:
      listData = [
        {
          id: CommonEnums.brandStatus?.active?.key,
          itemName: CommonEnums.brandStatus?.active?.value,
        },
        {
          id: CommonEnums.brandStatus?.agency_draft?.key,
          itemName: CommonEnums.brandStatus?.agency_draft?.value,
        },
        {
          id: CommonEnums.brandStatus?.admin_draft?.key,
          itemName: CommonEnums.brandStatus?.admin_draft?.value,
        },
        {
          id: CommonEnums.brandStatus?.deactivated?.key,
          itemName: CommonEnums.brandStatus?.deactivated?.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.brand_country:
      listData = [
        {
          id: CommonEnums.brandCountry?.Australia?.key,
          itemName: CommonEnums.brandCountry?.Australia?.value,
        },
        {
          id: CommonEnums.brandCountry?.new_zealand?.key,
          itemName: CommonEnums.brandCountry?.new_zealand?.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.registration_status:
      listData = [
        {
          id: CommonEnums.inviteStatus?.pending_for_profile_completion?.key,
          itemName:
            CommonEnums.inviteStatus?.pending_for_profile_completion?.value,
        },

        {
          id: CommonEnums.inviteStatus?.pending_for_subscription?.key,
          itemName: CommonEnums.inviteStatus?.pending_for_subscription?.value,
        },
        {
          id: CommonEnums.inviteStatus?.pending_for_registration?.key,
          itemName: CommonEnums.inviteStatus?.pending_for_registration?.value,
        },
        {
          id: CommonEnums.inviteStatus?.completed?.key,
          itemName: CommonEnums.inviteStatus?.completed?.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.post_type:
      listData = [
        {
          id: CommonEnums.postType?.image_post?.key,
          itemName: CommonEnums.postType?.image_post?.value,
        },

        {
          id: CommonEnums.postType?.reel_post?.key,
          itemName: CommonEnums.postType?.reel_post?.value,
        },
        {
          id: CommonEnums.postType?.story_post?.key,
          itemName: CommonEnums.postType?.story_post?.value,
        },
        {
          id: CommonEnums.postType?.video_post?.key,
          itemName: CommonEnums.postType?.video_post?.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.listing_type:
      listData = [
        {
          id: CommonEnums.listingType?.for_rent?.key,
          itemName: CommonEnums.listingType?.for_rent?.value,
        },
        {
          id: CommonEnums.listingType?.for_sale?.key,
          itemName: CommonEnums.listingType?.for_sale?.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.listing_type_all:
      listData = [
        {
          id: "all",
          itemName: "All",
        },
        {
          id: CommonEnums.listingType?.for_rent?.key,
          itemName: CommonEnums.listingType?.for_rent?.value,
        },
        {
          id: CommonEnums.listingType?.for_sell?.key,
          itemName: CommonEnums.listingType?.for_sell?.value,
        },
      ];
      break;

    case CommonEnums?.selectorType?.user_role:
      listData = [
        {
          id: CommonEnums?.mainUserRole?.all?.key,
          itemName: CommonEnums?.mainUserRole?.all?.value,
        },
        {
          id: CommonEnums?.mainUserRole?.admin_role?.key,
          itemName: CommonEnums?.mainUserRole?.admin_role?.value,
        },
        {
          id: CommonEnums?.mainUserRole?.client_role?.key,
          itemName: CommonEnums?.mainUserRole?.client_role?.value,
        },
      ];
      break;
  }

  return (
    <div className="user-status-contain">
      <p className="user-status-head">{placeholder}</p>
      <FormControl fullWidth className="user-filter-selector">
        {!formik?.values[type] && (
          <div className="user-status-placeholder">
            <p>{`Select ${placeholder}`}</p>
          </div>
        )}

        <div className={`filter-down-arrow-icon `}>
          {formik?.values[type] ? (
            <div
              className="reporting-manager-close-icon"
              onClick={onClickRemove}
            >
              <CloseIcon />
            </div>
          ) : (
            <div>
              <DownArrowIcon />
            </div>
          )}
        </div>
        <Select
          labelId="demo-simple-select-label"
          onChange={formik?.handleChange}
          name={type}
          value={formik?.values[type]}
          // IconComponent={state?.isLoading ? LoadingIcon : KeyboardArrowDownIcon}
          // inputComponent={DisableBtn}
          disabled={formik?.values[type] ? true : false}
          MenuProps={{
            disablePortal: true,
            classes: {
              paper: "selector-menu-container",
            },
          }}
        >
          {listData?.length ? (
            listData?.map((data: any) => (
              <MenuItem value={data?.id} key={data?.id}>
                {data?.itemName}
              </MenuItem>
            ))
          ) : (
            <div className="role-list-not-found">
              <p>Type not found!</p>
            </div>
          )}
        </Select>
      </FormControl>
    </div>
  );
};

export default FixDataFilterSelector;
